'use strict';

var _possibleConstructorReturn = require("D:\\Development\\Templates\\live\\all-in-one\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Development\\Templates\\live\\all-in-one\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\Development\\Templates\\live\\all-in-one\\node_modules\\@babel\\runtime/helpers/inherits");

var _regeneratorRuntime = require("D:\\Development\\Templates\\live\\all-in-one\\node_modules\\@babel\\runtime/regenerator");

var _toConsumableArray = require("D:\\Development\\Templates\\live\\all-in-one\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _asyncToGenerator = require("D:\\Development\\Templates\\live\\all-in-one\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _classCallCheck = require("D:\\Development\\Templates\\live\\all-in-one\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Development\\Templates\\live\\all-in-one\\node_modules\\@babel\\runtime/helpers/createClass");

var anyMap = new WeakMap();
var eventsMap = new WeakMap();
var resolvedPromise = Promise.resolve();

function assertEventName(eventName) {
  if (typeof eventName !== 'string') {
    throw new TypeError('eventName must be a string');
  }
}

function assertListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('listener must be a function');
  }
}

function getListeners(instance, eventName) {
  var events = eventsMap.get(instance);

  if (!events.has(eventName)) {
    events.set(eventName, new Set());
  }

  return events.get(eventName);
}

var Emittery =
/*#__PURE__*/
function () {
  function Emittery() {
    _classCallCheck(this, Emittery);

    anyMap.set(this, new Set());
    eventsMap.set(this, new Map());
  }

  _createClass(Emittery, [{
    key: "on",
    value: function on(eventName, listener) {
      assertEventName(eventName);
      assertListener(listener);
      getListeners(this, eventName).add(listener);
      return this.off.bind(this, eventName, listener);
    }
  }, {
    key: "off",
    value: function off(eventName, listener) {
      assertEventName(eventName);
      assertListener(listener);
      getListeners(this, eventName).delete(listener);
    }
  }, {
    key: "once",
    value: function once(eventName) {
      var _this = this;

      return new Promise(function (resolve) {
        assertEventName(eventName);

        var off = _this.on(eventName, function (data) {
          off();
          resolve(data);
        });
      });
    }
  }, {
    key: "emit",
    value: function () {
      var _emit = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(eventName, eventData) {
        var listeners, anyListeners, staticListeners, staticAnyListeners;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                assertEventName(eventName);
                listeners = getListeners(this, eventName);
                anyListeners = anyMap.get(this);
                staticListeners = _toConsumableArray(listeners);
                staticAnyListeners = _toConsumableArray(anyListeners);
                _context3.next = 7;
                return resolvedPromise;

              case 7:
                return _context3.abrupt("return", Promise.all([].concat(_toConsumableArray(staticListeners.map(
                /*#__PURE__*/
                function () {
                  var _ref = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee(listener) {
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!listeners.has(listener)) {
                              _context.next = 2;
                              break;
                            }

                            return _context.abrupt("return", listener(eventData));

                          case 2:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, this);
                  }));

                  return function (_x3) {
                    return _ref.apply(this, arguments);
                  };
                }())), _toConsumableArray(staticAnyListeners.map(
                /*#__PURE__*/
                function () {
                  var _ref2 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee2(listener) {
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!anyListeners.has(listener)) {
                              _context2.next = 2;
                              break;
                            }

                            return _context2.abrupt("return", listener(eventName, eventData));

                          case 2:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, this);
                  }));

                  return function (_x4) {
                    return _ref2.apply(this, arguments);
                  };
                }())))));

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function emit(_x, _x2) {
        return _emit.apply(this, arguments);
      }

      return emit;
    }()
  }, {
    key: "emitSerial",
    value: function () {
      var _emitSerial = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(eventName, eventData) {
        var listeners, anyListeners, staticListeners, staticAnyListeners, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, listener, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _listener;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                assertEventName(eventName);
                listeners = getListeners(this, eventName);
                anyListeners = anyMap.get(this);
                staticListeners = _toConsumableArray(listeners);
                staticAnyListeners = _toConsumableArray(anyListeners);
                _context4.next = 7;
                return resolvedPromise;

              case 7:
                /* eslint-disable no-await-in-loop */
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context4.prev = 10;
                _iterator = staticListeners[Symbol.iterator]();

              case 12:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context4.next = 20;
                  break;
                }

                listener = _step.value;

                if (!listeners.has(listener)) {
                  _context4.next = 17;
                  break;
                }

                _context4.next = 17;
                return listener(eventData);

              case 17:
                _iteratorNormalCompletion = true;
                _context4.next = 12;
                break;

              case 20:
                _context4.next = 26;
                break;

              case 22:
                _context4.prev = 22;
                _context4.t0 = _context4["catch"](10);
                _didIteratorError = true;
                _iteratorError = _context4.t0;

              case 26:
                _context4.prev = 26;
                _context4.prev = 27;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 29:
                _context4.prev = 29;

                if (!_didIteratorError) {
                  _context4.next = 32;
                  break;
                }

                throw _iteratorError;

              case 32:
                return _context4.finish(29);

              case 33:
                return _context4.finish(26);

              case 34:
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context4.prev = 37;
                _iterator2 = staticAnyListeners[Symbol.iterator]();

              case 39:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context4.next = 47;
                  break;
                }

                _listener = _step2.value;

                if (!anyListeners.has(_listener)) {
                  _context4.next = 44;
                  break;
                }

                _context4.next = 44;
                return _listener(eventName, eventData);

              case 44:
                _iteratorNormalCompletion2 = true;
                _context4.next = 39;
                break;

              case 47:
                _context4.next = 53;
                break;

              case 49:
                _context4.prev = 49;
                _context4.t1 = _context4["catch"](37);
                _didIteratorError2 = true;
                _iteratorError2 = _context4.t1;

              case 53:
                _context4.prev = 53;
                _context4.prev = 54;

                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }

              case 56:
                _context4.prev = 56;

                if (!_didIteratorError2) {
                  _context4.next = 59;
                  break;
                }

                throw _iteratorError2;

              case 59:
                return _context4.finish(56);

              case 60:
                return _context4.finish(53);

              case 61:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[10, 22, 26, 34], [27,, 29, 33], [37, 49, 53, 61], [54,, 56, 60]]);
      }));

      function emitSerial(_x5, _x6) {
        return _emitSerial.apply(this, arguments);
      }

      return emitSerial;
    }()
  }, {
    key: "onAny",
    value: function onAny(listener) {
      assertListener(listener);
      anyMap.get(this).add(listener);
      return this.offAny.bind(this, listener);
    }
  }, {
    key: "offAny",
    value: function offAny(listener) {
      assertListener(listener);
      anyMap.get(this).delete(listener);
    }
  }, {
    key: "clearListeners",
    value: function clearListeners(eventName) {
      if (typeof eventName === 'string') {
        getListeners(this, eventName).clear();
      } else {
        anyMap.get(this).clear();
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = eventsMap.get(this).values()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var listeners = _step3.value;
            listeners.clear();
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }
    }
  }, {
    key: "listenerCount",
    value: function listenerCount(eventName) {
      if (typeof eventName === 'string') {
        return anyMap.get(this).size + getListeners(this, eventName).size;
      }

      if (typeof eventName !== 'undefined') {
        assertEventName(eventName);
      }

      var count = anyMap.get(this).size;
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = eventsMap.get(this).values()[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var value = _step4.value;
          count += value.size;
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return count;
    }
  }]);

  return Emittery;
}(); // Subclass used to encourage TS users to type their events.


Emittery.Typed =
/*#__PURE__*/
function (_Emittery) {
  _inherits(_class, _Emittery);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
  }

  return _class;
}(Emittery);

Object.defineProperty(Emittery.Typed, 'Typed', {
  enumerable: false,
  value: undefined
});
module.exports = Emittery;